/* 🤖 this file was generated by svg-to-ts */
export const matIconPanoramaFishEye: {
  name: 'panorama-fish-eye';
  data: string;
} = {
  name: 'panorama-fish-eye',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>`
};
